import styled from 'styled-components';

export const FormContent = styled.div<{ isField: boolean }>`
  display: grid;
  grid-template-columns: repeat(3, 288px);
  grid-column-gap: 48px;

  ${({ isField }) =>
    !isField
      ? `
    & > div:nth-child(even) {
      grid-row: 2;
    } 
  `
      : `
    grid-template-rows: repeat(3, 1fr);
    grid-auto-flow: column;

    .ant-form-item {
      margin-bottom: 0;
    }
  `}
`;

export const FormElementsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  & > div:last-child {
    align-self: flex-start;
    cursor: pointer;
  }
`;
